import CookieHelper from './cookieHelper';

export const ICONS_COOKIE = CookieHelper.CookieNameEnum.Icons;

// "I like icons" profile setting (default off): decorative icons — sidebar sub-menu
// item icons, tab-strip icons and the page-title icon — render only when the user
// opted in. Mirrors the legacy (pre-redesign) behaviour where submenubutton.js and
// the content.js page title gated their icons on this cookie. Structural icons
// (sidebar rail / top-level rows, buttons, window chrome) always show.
export function iconsEnabled() {
  return CookieHelper.getCookie(ICONS_COOKIE, 'false') === 'true';
}
